<p-toast position="center"></p-toast>
<p-button class="cart-button" label="Enquire" badge="{{productCart.length}}" icon="pi pi-shopping-cart"
    (onClick)="toggleSideBar()"></p-button>
<div class="container-fluid custom-width">
    <div class="row" *ngFor="let productsList of productsChunk; index as i">
        <div *ngFor="let product of productsList" class="col-custom mb-3">
            <ft-product-card [product]="product" [productCart]="productCart"></ft-product-card>
        </div>
    </div>
    <div *ngIf="products && products.length > 0">
        <div class="row justify-content-center">
            <ecom-item-count
                [params]="{ page: page, totalItems: totalItems, itemsPerPage: itemsPerPage }"></ecom-item-count>
        </div>
        <div class="row justify-content-center">
            <ngb-pagination [collectionSize]="totalItems" [(page)]="ngbPaginationPage" [pageSize]="itemsPerPage"
                [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage($event)"></ngb-pagination>
        </div>
    </div>
</div>
<div *ngIf="showSideBar">
    <p-sidebar [(visible)]="showSideBar" position="right" [baseZIndex]="10000" [ngStyle]="{width:'40rem'}">
        <app-product-cart [productCart]="productCart" (closeCart)="closeSideBar()"></app-product-cart>
    </p-sidebar>
</div>
